 <template>
  <div
    :class="[
      'eightPage',
      pageEightAction ? 'animated pageFadeIn' : 'pageFadeOut',
    ]"
  >
    <div
      :class="[
        'eightIconPng',
        eightTitShow ? 'imgAnimated imgFadeIn' : 'bgGray',
      ]"
    ></div>
    <div :class="['titHeader']" v-if="eightTitShow">
      <p class="animated flipInY">奋进新时代，开启新征途</p>
      <span class="circle circleOne"></span>
      <span class="circle"></span>
    </div>
    <div class="titBox">
      <!-- <h4 class="tit animated flipInY" v-if="eightTitShow">
        奋进新时代，开启新征途
      </h4> -->
      <p class="textMian animated delay fadeIn" v-if="eightTitShow">
        2020年12月，我院成功取得安徽省自然资源厅颁发的乙级测绘资质证书。为我院今后承担地理信息相关工作提供了资格保障，同时将为我院实现生态空间监测一体化服务迈出实质性的一大步。
      </p>
    </div>
    <div class="bwBox" v-if="eightBtnShow" @click="changeHue">
      <div class="wave wave4"></div>
      <div class="wave wave3"></div>
      <div class="wave wave1"></div>
      <div class="wave waveOne">
        <!-- <img :src="baseUrl + 'img/dhShare/dianEight.png'" class="textAmation" /> -->
        <img :src="baseUrl + 'img/dhShare/dianIcon.png'" class="textAmation" />
      </div>
    </div>
    <div :class="['imgMainBox', eightTitShow ? 'imgMainBoxShow' : '']">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperChild">
        <swiper-slide
          class="slideItem"
          v-for="(item, index) in slideList"
          :key="index"
        >
          <van-image
            fit="cover"
            @click="seeImg(item, index)"
            :src="baseUrl + item.imgUrl"
          />
        </swiper-slide>
      </swiper>
    </div>

    <van-overlay @click="bigImgShow = false" class="tkMain" :show="bigImgShow">
      <div class="wrapper">
        <van-image
          fit="cover"
          :src="baseUrl + bigImgUrl + '?x-oss-process=image/resize,p_50'"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import "@/assets/style/animate.min.less";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/style/animate.min.less";
export default {
  name: "eightPage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      eightTitShow: false,
      pageEightAction: false,
      eightBtnShow: true,
      bigImgShow: false,
      swiperOption: {
        loop: false,
        slidesPerView: 3, //数量
        spaceBetween: 15, //间距
        initialSlide: 1,
        centeredSlides: true,
        direction: "horizontal", //设置水平horizontal还是垂直vertical
      },
      bigImgUrl: "",
      slideList: [
        {
          imgUrl: "img/dhShare/eightK001.jpg",
        },
        {
          imgUrl: "img/dhShare/eightK002.jpg",
        },
        {
          imgUrl: "img/dhShare/eightK003.jpg",
        },
        {
          imgUrl: "img/dhShare/eightK004.jpg",
        },
        {
          imgUrl: "img/dhShare/eightK005.jpg",
        },
        {
          imgUrl: "img/dhShare/eightK006.jpg",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.typePage = this.landscapeType;
      this.initPage();
    });
  },
  methods: {
    initPage() {
      this.pageEightAction = true;
    },
    changeHue() {
      this.eightBtnShow = false;
      this.eightTitShow = true;
    },
    seeImg(item) {
      this.bigImgShow = true;
      this.bigImgUrl = item.imgUrl;
    },
  },
  watch: {
    landscapeType: function (newVal) {
      this.typeType = newVal;
    },
    newIndex: function (newValue) {
      if (newValue == "7") {
        this.pageEightAction = true;
      } else {
        this.pageEightAction = false;
      }
    },
  },
};
</script>
<style lang="less">
.eightPage {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/dhShare/slideEight.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  .eightIconPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/eightIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: relative;
    -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
    filter: grayscale(100%);
  }
  .titHeader {
    top: 120px;
    right: -45px;
    border: 1px solid #fafe77;
    color: #fafe77;
    background-color: rgba(225, 225, 225, 0.5);
    p {
      opacity: 0;
    }
    .circle {
      border: 1px solid #fafe77;
    }
  }
  .titBox {
    position: absolute;
    top: 30px;
    right: 20px;
    .textMian {
      width: 200px;
      position: absolute;
      text-align: justify;
      left: 20px;
      top: 45px;
      font-size: 12px;
      color: #fafe77;
      opacity: 0;
    }
  }
  .imgMainBox {
    display: none;
    position: absolute;
    bottom: 25px;
    left: 0;
    // -webkit-transform: rotate(90deg);
    // transform: rotate(90deg);
    z-index: 999;
    width: 100%;

    .swiperChild.swiper-container {
      width: 320px;
      height: 120px;
      .swiper-wrapper {
        margin-top: 15px;
        .slideItem.swiper-slide {
          width: 110px;
          height: 95px;
          background-color: #fff;
          z-index: 1000;
          border-radius: 10px;
          -webkit-border-radius: 10px;
          padding: 5px 5px;
          opacity: 0.7;
          .van-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            img {
              border-radius: 8px;
            }
          }
        }
        .slideItem.swiper-slide.swiper-slide-active {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    }
  }
  .tkMain.van-overlay {
    position: absolute !important;
    width: 100% !important;
    height: 75% !important;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: rgba(225, 225, 225, 0);
    overflow: hidden;

    .wrapper {
      position: absolute;
      width: 320px;
      height: 450px;
      background-color: #fff;
      padding: 5px 5px;
      left: 50%;
      top: 50%;
      margin-left: -155px;
      margin-top: -210px;
      border-radius: 10px;
      -webkit-border-radius: 10px;
    }

    .van-image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      img {
        border-radius: 8px;
      }
    }
  }
  .imgMainBox.imgMainBoxShow {
    display: block;
  }
}
</style>